import { c as _c } from "react/compiler-runtime";
export default function BlockPickerDateSelect(t0) {
  const $ = _c(17);
  const {
    date,
    setDate,
    time,
    setTime
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-100">Select date</label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Date().toISOString().slice(0, 10);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== setDate) {
    t3 = e => setDate(e.target.value);
    $[2] = setDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== date || $[5] !== t3) {
    t4 = <div className="tw-w-full">{t1}<div className="tw-mt-1.5"><input type="date" name="block-picker-date" id="block-picker-date" value={date} required={true} min={t2} onChange={t3} onClick={_temp} className="tw-cursor-pointer tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-700/40 tw-text-white tw-font-light tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700/40 placeholder:tw-text-iron-500  focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-700 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div></div>;
    $[4] = date;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-100">Select time</label>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = !date;
  let t7;
  if ($[8] !== setTime) {
    t7 = e_1 => setTime(e_1.target.value);
    $[8] = setTime;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7 || $[12] !== time) {
    t8 = <div className="tw-w-full">{t5}<div className="tw-mt-1.5"><input type="time" step="1" name="block-picker-time" id="block-picker-time" value={time} required={true} disabled={t6} onChange={t7} onClick={_temp2} className="tw-cursor-pointer tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-700/40 tw-text-white tw-font-light tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700/40 placeholder:tw-text-iron-500  focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-700 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div></div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = time;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t8) {
    t9 = <div className="tw-gap-x-4 tw-flex tw-w-full">{t4}{t8}</div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function _temp2(e_2) {
  return e_2.target.showPicker();
}
function _temp(e_0) {
  return e_0.target.showPicker();
}